import { Platform } from 'react-native';

export function deferOnWeb(callback: () => void): void {
  if (Platform.OS === 'web') {
    void Promise.resolve().then(callback);
  } else {
    callback();
  }
}
